function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddi = function SvgAddi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "M19.112 11h-6.111V4.889a.95.95 0 0 0-1-.889.95.95 0 0 0-1 .889V11h-6.11a.95.95 0 0 0-.889 1 .95.95 0 0 0 .239.683.95.95 0 0 0 .65.317h6.111v6.111c.015.25.129.484.317.651a.95.95 0 0 0 .683.238.95.95 0 0 0 .683-.238.95.95 0 0 0 .317-.651V13h6.111a.95.95 0 0 0 .65-.317.95.95 0 0 0 .239-.683.95.95 0 0 0-.89-1"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddi);
export default ForwardRef;